import { generateClient } from "aws-amplify/api";
import { stripePayment } from "../graphql/mutations";

const client = generateClient();

const StripeUrlService = {
  async getPaymentUrl(stripePriceId, quantity, email, billingCycle) {
    try {
      const response = await client.graphql({
        query: stripePayment,
        variables: { stripePriceId, quantity, email, billingCycle },
        authMode: "userPool",
      });

      return response.data.stripePayment;
    } catch (error) {
      console.error("Error fetching payment URL:", error);
      throw error;
    }
  },
};

export default StripeUrlService;
